import { render } from "./VerticalStepComponent.vue?vue&type=template&id=d1409da4&ts=true"
import script from "./VerticalStepComponent?vue&type=script&lang=ts"
export * from "./VerticalStepComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__